var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutboundCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#4A505B",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08982 7.12134C9.04518 7.12271 8.99991 7.12957 8.95604 7.14282C8.63804 7.23932 8.49221 7.60678 8.65721 7.89478L10.334 10.8196L7.78709 11.4915L7.0449 10.8674C6.9434 10.7819 6.80569 10.7537 6.67869 10.7922C6.43469 10.8652 6.32313 11.1484 6.45213 11.3684L7.09666 12.468C7.32366 12.855 7.77985 13.0439 8.21385 12.9299L15.5762 10.9905C15.5771 10.9902 15.5781 10.9898 15.5791 10.9895C15.7527 10.959 15.9101 10.8682 16.0235 10.7332C16.1369 10.5982 16.1991 10.4275 16.1992 10.2512C16.1992 10.0523 16.1202 9.86154 15.9795 9.72089C15.8389 9.58024 15.6481 9.50122 15.4492 9.50122C15.3839 9.50123 15.3189 9.50977 15.2558 9.52661V9.52564L12.6406 10.2141L9.45701 7.25903C9.35614 7.16528 9.22375 7.11721 9.08982 7.12134ZM6.99998 14.5012C6.72398 14.5012 6.49998 14.7252 6.49998 15.0012C6.49998 15.2772 6.72398 15.5012 6.99998 15.5012H15C15.276 15.5012 15.5 15.2772 15.5 15.0012C15.5 14.7252 15.276 14.5012 15 14.5012H6.99998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboundCircle);
export default __webpack_public_path__ + "static/media/outbound_circle.0649b6d017208a8185215ab110dbc58e.svg";
export { ForwardRef as ReactComponent };